import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Button, Card, CardActions, CardContent, CardHeader, Divider } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import clsx from 'clsx';
import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { Link, useHistory } from 'react-router-dom';
import { DashboardPanelContext } from '../../../../components/context/DashboardContext';
import BSubmitButton from '../../../../components/buttons/SubmitButton';
import BCheckBoxField from '../../../../components/inputs/forms/BCheckBoxField';
import { REQUIRED_STRING } from '../../../../constants/HookForm';
import BTextField from '../../../../components/inputs/forms/BTextField';
import {
  setValues,
  onChangeForBComponents,
  onKeyDownHandlerOnlyAcceptEnglishCharacterAndNumbers,
  onKeyDownHandlerOnlyAcceptIntegerEnglishDontAcceptSpace,
} from '../../../../common/utilities';
import { BSwalShowError } from '../../../../common/BSwal';
import useHistoryForms from '../../../../hooks/useHistoryForms';
import BHistoryNavigator from '../../../../components/BHistoryNavigator';
import useBasicInformationMountedEffect from '../../../../hooks/useBasicInformationMountedEffect';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  customInputFormControl: {
    width: '100%',
  },
  formLabel: {
    fontSize: 16,
    marginBottom: 10,
  },
}));

const initialjobType = {
  title: '',
  status: true,
};

const JobTypesPage = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const { staticContext, ...rest } = props;
  const { globalState, saveItem } = useContext(DashboardPanelContext);

  const { viewReadOnly } = globalState;

  const [loading, setLoading] = useState(false);
  const { errors, handleSubmit, setValue, register } = useForm();

  const {
    fetchData,
    prevHistory,
    nextHistory,
    HistoryId,
    historyIdList,
    historyStep,
    history: fetchedHistory,
    historyInfo,
  } = useHistoryForms({
    location: props.location,
    route: '/order-management/job-types',
  });

  const {
    id,
    item: currentJobType,
    setItem: setCurrentJobType,
  } = useBasicInformationMountedEffect({
    match: props.match,
    historyIdList,
    fetchItemURL: '/job-types',
    localStorageKey: 'job-types',
    initialItem: initialjobType,
    fetchData,
    historyId: HistoryId,
  });

  useEffect(() => {
    if (!viewReadOnly) {
      register(
        { name: 'title' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'private_price_1' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'insurance_price_1' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'price_2' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'price_3' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'description' },
        {
          required: REQUIRED_STRING,
        },
      );
    }
  }, []);

  useEffect(() => {
    if (currentJobType.data) {
      setCurrentJobType(currentJobType.data);
    }
    if (currentJobType) {
      setValues(setValue, currentJobType);
    }
  }, [currentJobType]);

  useEffect(() => {
    if (fetchedHistory && historyIdList.length !== 0) {
      setCurrentJobType(fetchedHistory);
    }
  }, [fetchedHistory]);

  const onSubmit = () => {
    setLoading(true);
    const jobType = { ...currentJobType };
    if (currentJobType.status) {
      jobType.status = '1';
    } else {
      jobType.status = '0';
    }
    saveItem('job-types', jobType, id)
      .then(() => history.push('/order-management/job-types'))
      .catch((err) => BSwalShowError(err?.data?.messages))
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    onChangeForBComponents(e, setValue, currentJobType, setCurrentJobType);
  };

  return (
    <div className={classes.root} style={{ margin: 10 }}>
      {currentJobType && (
        <Card {...rest} className={clsx(classes.root)}>
          <Button
            id='backToListIcon'
            component={Link}
            to={{
              pathname: '/order-management/job-types',
            }}
            color='secondary'
            variant='outlined'
            style={{ float: 'right', marginTop: '10px', marginRight: '10px' }}
          >
            <ArrowBackIcon />
          </Button>
          <form className='formContainer' onSubmit={handleSubmit(onSubmit)}>
            <CardHeader title='Job Type Information' />
            <Divider />
            <CardContent>
              <br />
              {historyInfo}
              <Grid container spacing={3}>
                <BTextField
                  label='Title'
                  name='title'
                  value={currentJobType?.title}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptEnglishCharacterAndNumbers}
                  error={errors.title}
                  required
                />

                <BTextField
                  label='Private Price-1 (Low price - not home)'
                  name='private_price_1'
                  value={currentJobType?.private_price_1}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptIntegerEnglishDontAcceptSpace}
                  error={errors.private_price_1}
                  required
                />

                <BTextField
                  label='Insurance Price-1 (Low price - not home)'
                  name='insurance_price_1'
                  value={currentJobType?.insurance_price_1}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptIntegerEnglishDontAcceptSpace}
                  error={errors.insurance_price_1}
                  required
                />

                <BTextField
                  label='Price-2 (Just inspect)'
                  name='price_2'
                  value={currentJobType?.price_2}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptIntegerEnglishDontAcceptSpace}
                  error={errors.price_2}
                  required
                />

                <BTextField
                  label='Price-3 (Complete Price)'
                  name='price_3'
                  value={currentJobType?.price_3}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptIntegerEnglishDontAcceptSpace}
                  error={errors.price_3}
                  required
                />

                <BTextField
                  label='Price-4 (Manual adding for an extra job)'
                  name='price_4'
                  value={currentJobType?.price_4}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptIntegerEnglishDontAcceptSpace}
                  error={errors.price_4}
                />

                <BTextField
                  label='Description'
                  name='description'
                  sm={12}
                  value={currentJobType?.description}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  error={errors.description}
                  required
                />

                <BCheckBoxField
                  sm={12}
                  name='status'
                  label='Enabled Status'
                  value={Number(currentJobType?.status)}
                  error={errors.status}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Grid item xs={12} sm={6}>
                {!viewReadOnly && <BSubmitButton id='submitEmployee' label='Save Job Type' loading={loading} />}
              </Grid>
              <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  id='backToList'
                  component={Link}
                  to={{
                    pathname: '/order-management/job-types',
                  }}
                  color='secondary'
                  variant='outlined'
                >
                  Back to Job Type list
                </Button>
              </Grid>
            </CardActions>
          </form>
          <BHistoryNavigator
            historyStep={historyStep}
            historyIdList={historyIdList}
            prevHistory={prevHistory}
            nextHistory={nextHistory}
          />
        </Card>
      )}
    </div>
  );
};

JobTypesPage.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
};

export default JobTypesPage;
